// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"3a774826","703":"66821294"}[chunkId] + ".chunk.js";
};